import {Injectable} from "@angular/core";
import {AbstractService} from "../../../../services/AbstractService";
import {LlmSettingsDTO} from "../../llm-settings/models/llm-settings.dto";
import {PromptsDTO} from "../models/promts.dto";
import {OrganisationDTO} from "../../../../DTO/Organisation/OrganisationDTO";
import {Observable} from "rxjs";
import {environment} from "../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class PromtsManagemetServices extends AbstractService<PromptsDTO> {

  override getApiURL() {
    return 'prompts';
  }

  getOrganizationPromts(organization: OrganisationDTO): Observable<PromptsDTO> {
    return this.http.get<PromptsDTO>(`${environment.apiUrl}${this.getApiURL()}/organisation/${organization.id}`);
  }

  getPromptById(id: number): Observable<any> {
    return this.http.get(`${environment.apiUrl}${this.getApiURL()}/${id}`);
  }

  override update(prompt: PromptsDTO): Observable<any> {
    return this.http.put(`${environment.apiUrl}${this.getApiURL()}/prompt/${prompt.id}`, prompt);
  }

  patchOrganizationPromts(id: any, patchOperations: any[]): Observable<any> {
    return this.http.patch<any>(
      `${environment.apiUrl}${this.getApiURL()}/${id}`,
      patchOperations,
      {
        headers: {"Content-Type": "application/json-patch+json"}
      }
    );
  }

  deletePrompt(id: number): Observable<any> {
    return this.http.delete<any>(`${environment.apiUrl}${this.getApiURL()}/${id}`);
  }
}
